<template>
    <section class="member-only-access">
        <h2 class="card-header">CAC MEMBER ONLY ACCESS</h2>
        <p class="body-book">Must show proof of CAC membership to access sites on this event</p>

        <a href="https://www.architecture.org/join-give/join/membership/" target="_blank" class="button">Become A Member</a>
    </section>
</template>

<style lang="scss" scoped>
    .member-only-access {
        text-align: center;
        padding: 20px 16px;
        background: $gray-light;
        margin-top: 20px;

        .body-book {
            margin: 12px 0;
        }

        .button {
            color: $white;
            background-color: $red;
            padding: 11px 25px 11px;
            display: inline-block;
            width: auto;
        }
    }
</style>
